import { useEffect, useState } from "react";
import { useSearchParams } from "react-router-dom";

export default function AutopayComplete() {
  const [params] = useSearchParams();
  const [status, setStatus] = useState("loading"); // loading | success | error

  const setupIntent = params.get("setup_intent");
  const redirectStatus = params.get("redirect_status");

  useEffect(() => {
    // Stripe tells us whether setup succeeded
    if (redirectStatus === "succeeded") {
      setStatus("success");
    } else {
      setStatus("error");
    }
  }, [redirectStatus]);

  return (
    <div className="min-h-screen p-10 text-white">
      <div className="max-w-xl mx-auto bg-white/10 p-8 rounded-2xl border border-white/10 backdrop-blur-md">
        {status === "loading" && (
          <>
            <h1 className="text-2xl mb-2">Finalising Direct Debit…</h1>
            <p className="text-gray-300">Please wait a moment.</p>
          </>
        )}

        {status === "success" && (
          <>
            <h1 className="text-2xl font-semibold mb-2">Direct Debit Set Up 🎉</h1>
            <p className="text-gray-300">
              Your rent will now be collected automatically each month.
            </p>

            <div className="mt-4 text-sm text-gray-400">
              SetupIntent ID: <strong>{setupIntent}</strong>
            </div>
          </>
        )}

        {status === "error" && (
          <>
            <h1 className="text-2xl font-semibold mb-2 text-red-400">
              Something Went Wrong
            </h1>
            <p className="text-gray-300 mb-4">
              We couldn’t verify the Direct Debit mandate.  
              Please try again or contact support.
            </p>
          </>
        )}
      </div>
    </div>
  );
}
